const toFiniteNumber = (value) => {
  const parsed = typeof value === 'number' ? value : parseFloat(value)

  return Number.isFinite(parsed) ? parsed : 0
}

export const resolveSubSystemMargin = ({ priceHKD, totalCost, storedGrossMargin } = {}) => {
  const price = toFiniteNumber(priceHKD)
  const cost = toFiniteNumber(totalCost)
  const storedGM = toFiniteNumber(storedGrossMargin)

  const resolvedCost = cost > 0 ? cost : (price * (100 - storedGM)) / 100
  const gmAmount = price - resolvedCost
  const gmPercentage = price > 0 ? (gmAmount / price) * 100 : storedGM

  return { cost: resolvedCost, gmAmount, gmPercentage }
}
